import React, { useState } from "react";
import styled from "styled-components";
import OrderBasicDetailCard from "./OrderBasicDetailCard";
import DisputeDetails from "./DisputeDetails/index";
import TripDetails from "./TripDetails/index";
import EstimatedDetails from "./EstimatedDetails/index";
import PayoutTimeline from "./PayoutTimeline/index";
import RainIntensity from "./RainIntensity";
import HorizontalTabs from "sushiweb/HorizontalTabs";
import { Tooltip } from "@material-ui/core";
import { isValNull, getPath } from "../../utils/index";
import {
  UserTypes,
  QueryTypes,
  OrderCategories,
  LifelineURLs,
} from "../../constants/OrderPayout/utils";
import { getDashboardUrl } from "../../views/Home";

const detailTabs = [
  "Payout Timeline",
  "Rider View",
  "Disputes",
  "Estimated Earnings",
  "Rain Intensity"
];

const OrderPayoutDetailCard = (props) => {
  const [activeIndex, setActiveIndex] = useState("Payout Timeline");
  const { data } = props;

  const dateTime = new Date(data.created_at).toLocaleString("en-US", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
  });

  const getUserDetails = (obj, type) => {
    if (!obj) {
      return [];
    }
    const details = Object.keys(obj).map((key) => {
      let detailObj = {
        key: key,
        value: obj[key],
        link: "",
        icon: "",
      };
      if (key === "id") {
        detailObj.value =
          (type === UserTypes.Driver)
          ? type + " #" +  obj["fe_id"] : type;
          if(type === UserTypes.Driver){
          detailObj.link = getLink(
            type,
            type === UserTypes.Driver ? obj["fe_id"] : obj[key]
          );
        }
      }

      if (
        key === "phone" ||
        key === "fe_id" ||
        key === "accounting_strategy" ||
        key === "address_details"
      ) {
        return "";
      }
      return detailObj;
    });
    return details;
  };

  const getLink = (type, id) => {
    let url = getDashboardUrl();
    if (type === UserTypes.Driver) {
      // return `/delivery-drivers/${id}/details`;
      url += `/admin/driver_support?driver_id=${id}`;
    }
    if (type === UserTypes.Merchant || type === UserTypes.Consumer) {
      url += `/admin/users/${id}`;
    }
    if (type === "Order") {
      url += `/admin/shipments/${id}`;
    }
    return url;
  };

  const getActiveComponent = () => {
    if (isValNull(data.trips) || data.trips.length == 0) {
      return <p>Trips Not Found</p>;
    }
    switch (activeIndex) {
      case "Rider View": {
        return (
          <React.Fragment>
            {data.trips.map((item, index) => {
              return <TripDetails tripDetails={item} />;
            })}
          </React.Fragment>
        );
      }
      case "Disputes": {
        return <DisputeDetails trips={data.trips} />;
      }
      case "Payout Timeline": {
        return <PayoutTimeline trips={data.trips} />;
      }
      case "Estimated Earnings": {
        return (
          <EstimatedDetails
            estimated_trip_details={data.trips.map(
              ({
                estimated_details,
                delivery_trip_id,
                flow_type,
                shipment_ref_id,
              }) => ({
                estimated_details,
                delivery_trip_id,
                flow_type,
                shipment_ref_id,
              })
            )}
          />
        );
      }
      case "Rain Intensity": 
      return <RainIntensity intensity={data.rain_intensity}/>
    }
  };
  const handleClick = (tab) => {
    setActiveIndex(tab);
  };
  return (
    <OrderPayoutDetailCardContainer className={"OrderCard"}>
      <OrderPayoutDetailHeader>
        {/*<a href={getLink("Order", data.external_order_id)} target={"_blank"}>Order #{data.external_order_id}</a>*/}
        <Tooltip
          title={"Click to open lifeline dashboard"}
          arrow
          placement={"top"}
          followCursor
        >
          <p
            onClick={() =>
              window.open(
                data.category == OrderCategories.Blinkit
                  ? `${LifelineURLs.Blinkit}type=${QueryTypes.OrderId}&value=${data.external_order_id}`
                  : `${LifelineURLs.Zomato}type=${QueryTypes.OrderId}&value=${data.external_order_id}`,
                "_blank"
              )
            }
            style={{
              color: "blue",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            Lifeline: Order #{data.external_order_id}
          </p>
        </Tooltip>
        <p>
          {data.source}, {data.category}
        </p>
      </OrderPayoutDetailHeader>

      <OrderBasicDetailWrapper>
        <OrderBasicDetailCard
          data={getUserDetails(
            { date: dateTime, status: "Status: " + data.order_status },
            ""
          )}
        />
        <OrderBasicDetailCard
          data={getUserDetails(data.customer, UserTypes.Consumer)}
          type={UserTypes.Consumer}
        />
        <OrderBasicDetailCard
          data={getUserDetails(data.merchant, UserTypes.Merchant)}
          type={UserTypes.Merchant}
          />
          {getPath(data, "trips", []).length > 0 ? (
            <OrderBasicDetailCard
              data={getUserDetails(
                data.trips[0].delivery_driver,
                UserTypes.Driver
              )}
              type={UserTypes.Driver}
            />
          ) : (
            <OrderBasicDetailCard data={null} type={UserTypes.Driver} />
          )}
      </OrderBasicDetailWrapper>

      <HorizontalTabs id="sushi-tabs" className="mt-30 mb-20" alignLinks="left">
        {detailTabs.map((tab, index) => {
          return (
            <HorizontalTabs.Link
              active={activeIndex == tab}
              onClick={() => handleClick(tab)}
              key={index}
              className={`tab${index}${activeIndex === tab}`}
            >
              {tab}
            </HorizontalTabs.Link>
          );
        })}
      </HorizontalTabs>
      {getActiveComponent()}
    </OrderPayoutDetailCardContainer>
  );
};

const OrderPayoutDetailCardContainer = styled.section`
  border: 0.5px solid #cfcfcf;
  padding: 20px;
  border-radius: 10px;
  margin: 20px;
`;
const OrderPayoutDetailHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  margin: 0 0 30px 0;
  font-weight: bold;
  border-bottom: 0.5px solid #cfcfcf;
`;
const OrderBasicDetailWrapper = styled.div`
  display: flex;
  justify-content: space-between; 
  gap: 20px; 
  flex-wrap: wrap;
  
  & > div {
    flex: 1; 
    min-width: 250px;
    max-width: 270px; 
    text-align: center; 
  }
`;








export default OrderPayoutDetailCard;
